
import React from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import BlogPage from '../pages/blog/page';
import BlogArticlePage from '../pages/blog/article/page';
import AdminPage from '../pages/admin/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
